import {Component, OnInit, Input, AfterViewInit, Output, EventEmitter} from '@angular/core';
import {BenchmarkPerformanceReportData, ReportSectionEnum} from '../../../../../models/measure/report';
import { CommonConstant } from '../../../../app.constants';
import {PdfExportService} from '../../../../services/export-pdf/pdf-export.service';
import {UserService} from '../../../../services/user.service';

enum BenchMarkStatusEnum {
  ASCENDING = 'asc',
  DESCENDING = 'desc'
}

@Component({
  selector: 'average-benchmark-performance-report',
  templateUrl: './average-benchmark-performance-report.component.html',
  styleUrls: ['./average-benchmark-performance-report.component.scss']
})
export class AverageBenchmarkPerformanceReportComponent implements OnInit, AfterViewInit {

  static COMPONENT_NAME = 'AverageBenchmarkPerformanceReportComponent';

  @Input() data: Array<BenchmarkPerformanceReportData>;
  @Input() public industryIndex: number;
  @Output() public changeBenchmarkPerformanceSettings: EventEmitter<any> = new EventEmitter<any>();
  public industryList: Array<{id: number, name: string}>;
  public benchmarkData: BenchmarkPerformanceReportData;
  public leftPercent: number;
  public isNoData: boolean;

  constructor(private pdfService: PdfExportService,
              private userService: UserService) { }

  ngOnInit() {
    this.isNoData = false;
    if (this.data && this.data.length === 0) {
      this.isNoData = true;
      return;
    }

    // get industry list
    if (this.data) {
      this.industryList = this.data
        .map((channel, index) => (
          {
            id: index,
            name: channel.menu.nameRight
          }
        ))
        .filter(channel => channel.name !== CommonConstant.NA_VALUE);

      if (this.industryIndex) {
        this.selectIndustry(this.industryIndex);
      } else if (this.industryList.length > 0) {
        this.industryIndex = this.industryList[0].id;
        this.selectIndustry(this.industryIndex);
      }
    }
  }

  ngAfterViewInit() {
    this.pdfService.incrementNumberReportReady(AverageBenchmarkPerformanceReportComponent.COMPONENT_NAME);
  }

  public selectIndustry(industryIndex) {
    if (industryIndex === null) {
      this.benchmarkData = new BenchmarkPerformanceReportData();
    } else {
      this.benchmarkData = this.data[industryIndex];
      this.changeBenchmarkPerformanceSettings.emit({
        reportType: ReportSectionEnum.INSIGHT_BENCHMARK_REPORT,
        value: industryIndex
      });
    }
  }

  // calculate percent and return if percent is bigger than 100
  public calculatePercent(percent, status) {
    const result = percent > 100 ? 50 : percent / 2;
    if (status === BenchMarkStatusEnum.ASCENDING) {
      this.leftPercent = 50 - result;
    } else {
      this.leftPercent = 50;
    }
    return Math.abs(result);
  }

  public isImpactType(item) {
    return item === CommonConstant.BENCHMARK_IMPACT;
  }

  public isAscending(item) {
    return item === BenchMarkStatusEnum.ASCENDING;
  }

  get isExportingPdfReport() {
    return this.pdfService.exportingPdf;
  }

  public chartColorByStatus(item) {
    return this.isAscending(item.status) ? this.userService.chartColors[CommonConstant.GREEN_COLOR_INDEX] : this.userService.chartColors[CommonConstant.RED_COLOR_INDEX];
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/average-benchmark-performance-report/average-benchmark-performance-report.component.ts